export default {
  'menu.bss': true,
  'menu.oss': true,
  'menu.oms': true,
  'menu.cms': true,
  'menu.dbm': false,
  'menu.bmr': false,
  'menu.ams': false
};
